var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2885 8.90166C10.2885 9.77339 9.6323 10.4709 8.57871 10.4709H8.5594C7.54497 10.4709 6.88916 9.77339 6.88916 8.90166C6.88916 8.0115 7.56494 7.3335 8.59862 7.3335C9.6323 7.3335 10.2689 8.0115 10.2885 8.90166ZM10.0894 11.7101V20.7889H7.06779V11.7101H10.0894ZM20.9866 20.7888L20.9867 15.5834C20.9867 12.7948 19.496 11.4969 17.5076 11.4969C15.9034 11.4969 15.1851 12.3781 14.7841 12.9963V11.7103H11.7621C11.8019 12.5622 11.7621 20.7891 11.7621 20.7891H14.7841V15.7188C14.7841 15.4474 14.8037 15.1767 14.8836 14.9825C15.1019 14.4404 15.5992 13.8792 16.434 13.8792C17.5278 13.8792 17.965 14.7117 17.965 15.9317V20.7888H20.9866Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a4440b3b.svg";
export { ForwardRef as ReactComponent };